import { FacilityInfoRow } from "../../types/facilityDrawer.types";

interface FacilityInfoGridProps {
  rows: FacilityInfoRow[];
}

const FacilityInfoGrid = ({ rows }: FacilityInfoGridProps) => (
  <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-4 tw-p-4">
    {rows.map(row => (
      <div key={row.label}>
        <p className="tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-muted-foreground tw-font-medium tw-mb-0.5">
          {row.label}
        </p>
        <p className="tw-text-sm tw-text-foreground tw-break-words">{row.value}</p>
      </div>
    ))}
  </div>
);

export default FacilityInfoGrid;
